import parse from "html-react-parser";

const AnnotationBlockRender = ({ text }: { text: string })  => {
    return(
        <section className="mb-12">
            <div className="general-annotaion-content-text-wrapper text-arcticMist">
                {text && parse(text)}
            </div>
        </section>
    )
}

export default AnnotationBlockRender;